import React, { createContext, useCallback, useContext, useState } from "react";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "../styles/themes";

interface ThemeContextData {
  toggleTheme(): void;
  theme: Theme;
}

interface Theme {
  name: string;
  colors: any;
  buttons: any;
  sizes: any;
  fontFamily: any;
  maxWidht: any;
}

const ThemeContext = createContext<ThemeContextData>({} as ThemeContextData);

export const useTheme = () => useContext(ThemeContext);

export const CustomThemeProvider: React.FC = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(defaultTheme);

  //Logica para alteração do tema
  const toggleTheme = useCallback(() => {
    // if (theme.name === "first") {
    //   setTheme(secondTheme);
    // } else if (theme.name === "second") {
    //   setTheme(firstTheme);
    // }

    console.log(setTheme);
    // eslint-disable-next-line
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ toggleTheme, theme }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
